<template>
  <v-hover v-slot="{ hover }">
    <v-card
        class="ma-4 pa-1 overflow-auto"
        :width=" width? width: 340"
        max-height="340"
        :elevation="hover ? 12 : 2"
        :color="(type=='Danger')? '#2A3B4D':'#FFFFFF'"
    >
        <v-list-item class="d-flex flex-wrap">
        <v-row
          justify="end"
        >
        <v-list-item-content 
        >
          <v-card-title :class="(type=='Danger') ? 'white--text':''" class="card-title"> {{totalcount.toLocaleString('en-US')}} </v-card-title>
              <v-card-subtitle>{{ title | translate }} </v-card-subtitle>
        </v-list-item-content>
        <v-icon class="card-image" :color="color"  v-if="type=='Admins'"> mdi-account-circle </v-icon>
        </v-row>

        <v-row>
            <v-list
                subheader
                two-line
                v-if="details.length && hover"
                min-width="200" 
              >
                <v-list-item class="ml-2" :class="(type=='Danger') ? 'white--text':''"  v-for="(admindetails,index) in details" :key="index">
                    <v-list-item-content>
                        <v-list-item-subtitle> <v-icon color="grey">mdi-star </v-icon> <a :href='"/users/edit/"+admindetails.user_id'> {{admindetails.name}} </a></v-list-item-subtitle>
                        <v-list-item-subtitle> <v-icon color="grey">mdi-email </v-icon> {{admindetails.email}}</v-list-item-subtitle>
                        <v-list-item-subtitle> <v-icon color="grey">mdi-phone </v-icon> {{admindetails.phone_no}}</v-list-item-subtitle>
                    </v-list-item-content>
                 </v-list-item>
              </v-list>
        </v-row>
      </v-list-item>

      

    </v-card>
  </v-hover>
</template>

<script>
export default {
  name: 'AdminCard',
    props: {
        width:Number,
        type: String,
        title: String,
        description: String,
        totalcount: Number,
        color: String,
        details: Array,
    }
}
</script>

<style scoped>
.card-title{
    font-size: 30px;
}

.card-image{
    font-size: 60px;
}
</style>